import { buildBonus11, buildWorld11 } from "./world1-1";
import { buildWorld12 } from "./world1-2";
import { buildWorld13 } from "./world1-3";
import { buildWorld14 } from "./world1-4";
import type { LevelDef } from "./types";

const LEVELS: Record<string, () => LevelDef> = {
  "1-1": buildWorld11,
  "1-1-bonus": buildBonus11,
  "1-2": buildWorld12,
  "1-3": buildWorld13,
  "1-4": buildWorld14,
};

export function getLevel(id: string): LevelDef {
  const build = LEVELS[id];
  if (!build) throw new Error(`Unknown level ${id}`);
  return build();
}

export function listLevels(): string[] {
  return Object.keys(LEVELS);
}

export type { LevelDef, EntitySpawn, WarpDest, LevelTheme } from "./types";
export {
  GROUND_ROW,
  LEVEL_ROWS,
  TILE,
  isSolidChar,
  isInteractiveChar,
  parseRows,
  tileToWorld,
  SOLID_TILES,
  INTERACTIVE_TILES,
  DECO_TILES,
  LAVA_TILES,
} from "./types";
